import {ReturnTextAndImg} from "../../test/CheckImg";
import './expert.css';
import Modal from '../Modal';
import Answer from './Answer';
import {ru} from "../../data/ru";
import {by} from "../../data/by";

const QuestionListItem = (props) => {
    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdSix : by.RoleIdSix;

    const {question, setQuestion, score, isChecked} = props;
    const text = ReturnTextAndImg(question, {'maxWidth': '200px', 'minWidth': '100px', 'height': 'inherit'})

    function componentOpenAnswer() {
        return (<div className="expert_check-button">Открыть</div>)
    }

    return (
        <>
            <div className="expert_question">
                <div className="expert_question-question">{text}</div>
                <div className={'expert_question_list_button'}>
                    {score !== null && <div className="expert_question-question"> {language.score}: {score}</div>}
                    <Modal style={{overflow: "scroll", height: "inherit"}}
                           additional={{...props, setQuestion: setQuestion, isChecked: isChecked}} component={Answer}
                           componentOpen={componentOpenAnswer}/>
                </div>
            </div>
            <hr/>
        </>
    )
}
export default QuestionListItem;
